import * as React from 'react'
import styles from './index.module.scss'

export interface LoadingTextProps {
    isLoading: boolean
    text?: string // по умолчанию "Загрузка"
    className?: string
}

export const LoadingText: React.FC<LoadingTextProps> = ({ isLoading, text = 'Загрузка', className }) => {
    if (!isLoading) {
        return null
    }

    const rootClassName = className ? `${styles.root} ${className}` : styles.root

    return (
        <span className={rootClassName}>
            {text}
            <span className={styles.dots} aria-hidden="true" />
        </span>
    )
}
